import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardComponent } from './dashboard/dashboard.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';

import { SharedModule } from '../shared/shared.module';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { SpinnerComponent } from './spinner/spinner.component';

@NgModule({
  declarations: [
    DashboardComponent,
    NavbarComponent,
    FooterComponent,
    SidebarComponent,
    SpinnerComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    // SpinnerComponent
  ],
  exports: [
    NavbarComponent,
    FooterComponent,
    SidebarComponent,
    SpinnerComponent
  ]
})
export class LayoutModule { }
